import apiUrl from "../util/apiURL";

const Version = "2016-03-04";
const Service = "vpc";

export default {
    //子网 acl别的调这个获取VPC的接口
    DescribeVpcInfos: apiUrl({
        Service: "vpc",
        Action: "DescribeTrustVpcInfos",
        Version
    }),
    //更换网络IP 子网禁用IP信息
    DescribeSubnetAllocatedIpAddresses: apiUrl({
        Service: "vpc",
        Action: "DescribeTrustSubnetAllocatedIpAddresses",
        Version
    }),
    // 查询子网内网IP信息
    DescribePrivateIpAddressAttributes: {
        url: apiUrl({
            Action: "DescribeTrustPrivateIpAddressAttributes",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    // 子网修改内网IP属性
    BatchModifyPrivateIpAddressAttribute: {
        url: apiUrl({
            Action: "BatchModifyTrustPrivateIpAddressAttribute",
            Service: "vpc",
            Version
        }),
        method: "post"
    },

    //批量修改一个安全组的安全组规则
    BatchEditSecurityGroupEntry: {
        url: apiUrl({
            Action: "BatchEditTrustSecurityGroupEntry",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    //批量替换安全组规则接口
    BatchReplaceSecurityGroupEntry: {
        url: apiUrl({
            Action: "BatchReplaceTrustSecurityGroupEntry",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    //批量新增安全组规则接口
    BatchAuthorizeSecurityGroupEntry: {
        url: apiUrl({
            Action: "BatchAuthorizeTrustSecurityGroupEntry",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    //批量删除安全组规则接口
    BatchRevokeSecurityGroupEntry: {
        url: apiUrl({
            Action: "BatchRevokeTrustSecurityGroupEntry",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    //复制安全组
    BatchCopySecurityGroupEntry: {
        url: apiUrl({
            Action: "BatchCopyTrustSecurityGroupEntry",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    // 更换网络
    ModifyNetworkInterfaceAttributes: {
        url: apiUrl({
            Action: "ModifyTrustNetworkInterfaceAttributes",
            Service: "kec",
            Version
        }),
        method: "post"
    },
  
    DescribeVpcs: apiUrl({
        Action: "DescribeTrustVpcs",
        Service,
        Version
    }),
  
  
    // 获取安全组数据
    DescribeSecurityGroups: apiUrl({
        Action: "DescribeTrustSecurityGroups",
        Service,
        Version
    }),
    DescribeInstances: apiUrl({
        Action: "DescribeTrustInstances",
        Service,
        Version
    }),
    DescribeNetworkInterfaces: apiUrl({
        Action: "DescribeTrustNetworkInterfaces",
        Service,
        Version
    }),
    ModifySecurityGroup: apiUrl({
        Action: "ModifyTrustSecurityGroup",
        Service,
        Version
    }),
    CreateSecurityGroup: apiUrl({
        Action: "CreateTrustSecurityGroup",
        Service,
        Version
    }),
    DeleteSecurityGroups: apiUrl({
        Action: "DeleteTrustSecurityGroups",
        Service,
        Version
    }),
    AuthorizeSecurityGroupEntry: apiUrl({
        Action: "AuthorizeTrustSecurityGroupEntry",
        Service,
        Version
    }),
    DeleteSecurityGroupEntrys: {
        url: apiUrl({
            Action: "DeleteTrustSecurityGroupEntrys",
            Service,
            Version
        }),
        method: "post"
    },
    ModifyNetworkInterfaceAttribute: apiUrl({
        Action: "ModifyTrustNetworkInterfaceAttribute",
        Service: "kec",
        Version
    }),
    ModifySecurityGroupEntry: {
        url: apiUrl({
            Action: "ModifyTrustSecurityGroupEntry",
            Service,
            Version
        }),
        method: "post"
    },
 
  
    DescribeSubnets: apiUrl({
        Action: "DescribeTrustSubnets",
        Service,
        Version
    }),
 

 
    QuerySubnet: apiUrl({
        Action: "QueryTrustSubnet",
        Service,
        Version
    }),
 
   
};
